module.exports = __webpack_public_path__ + "img/logo-gimmatek-2x.434b0ffb.png";